import React, { useEffect, useRef, useState } from "react";
// mui
import { CircularProgress, Grid2 } from "@mui/material";
// styling
import styles from "./Backups.module.scss";
// local import
import SiteHeaderCard from "../../Components/HeaderComponent/Header";
import BackupsTable from "../../Components/BackupsTable/BackupsTable";
import { toast } from "react-toastify";
import RestoreTable from "../../Components/RestoreTable/RestoreTable";
import TyTabs from "../../../../../../GlobalComponents/TyTabs/TyTabs";
import { ReactComponent as NightlyBackups } from "../../../../../../GlobalAssets/svg/NightlyBackups.svg";
import { ReactComponent as CloudOnDemandBackups } from "../../../../../../GlobalAssets/svg/CloudOnDemandBackups.svg";
import IconButton from "../../../../../../GlobalComponents/IconButton/IconButton";
import { useSelector } from "react-redux";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import {
  adminApi,
  CP,
  lastSegmentPath,
  STAGING,
} from "../../../../../../Utils/roconConstants";
import Popup from "../../../../../../GlobalComponents/Popup/Popup";
import CustomInput from "../../../../../../GlobalComponents/CustomInput/CustomInput";
import {
  getStagingEnv,
  siteDetails,
  staging,
} from "../../../../../../Utils/sitePages";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";

export default function Backups() {
  const [cardStatus, setCardStatus] = useState({
    title: "Backups",
    value: "BackupTable",
  });

  const [filterType, setFilterType] = useState("All");
  const [selectedButton, setSelectedButton] = useState("");
  const [onDemandPopup, setOnDemandPopup] = useState(false);
  const [onDemandName, setOnDemandName] = useState("");
  const [loading, setLoading] = useState(false);
  const [ebsRestoring, setEbsRestoring] = useState(false);

  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });

  let sites = useSelector((state) => state?.sitesInfo?.selectedSite);
  const isDedicated = sites?.dedicatedInstanceDetails;
  let organizationsInfo = useSelector(
    (state) => state.organizationsInfo.selectedOrg
  );

  const userDetails = useSelector((state) => state.users.userDetails?.theme);
  const dedicatedHosting = useSelector(
    (state) => state.plansInfo?.specificPlan?.isDedicated
  );

  const params = useParams();
  const navigate = useNavigate();
  const orgId = params.orgId;
  const siteId = params.siteId;
  // EBS (v2) sites: backups are EBS snapshots (/siteDetails/ebsBackups), not the S3 FS/DB backups
  const isEbsSite =
    sites?.ebsSite === true && String(sites?.siteId) === String(siteId);

  const siteData = siteDetails(sites);
  let livedom = siteData?.domain.find((item) => item.primary === "Y")?.name;
  const selectedDomain = useSelector((state) => state.sitesInfo.selectedDomain);

  const isStaging = staging(sites);
  const location = useLocation();
  const lastSegment = lastSegmentPath(location);

  useEffect(() => {
    // Backups and restores are never taken for a staging environment, so this page does
    // not exist for one. The sidebar hides the link and the environment switcher routes
    // away
    if (selectedDomain?.environment === "STAGING") {
      navigate(`/account/${orgId}/${siteId}/site-details`, { replace: true });
      return;
    }
    fetchData();
  }, [selectedDomain?.environment, siteId]);

  const selectTab = (newValue) => {
    setCardStatus(newValue);
    if (newValue.value === "BackupTable" || newValue.value === "RestoreTable") {
      setFilterType("All");
      setSelectedButton("");
    }
  };

  const handleNightlyClick = () => {
    setFilterType("Nightly");
    setSelectedButton("Nightly");
  };

  const handleOnDemandClick = () => {
    setFilterType("OnDemand");
    setSelectedButton("OnDemand");
  };

  const fetchData = () => {
    getStore().dispatch({
      type: Actions.API_GET_SELECTED_SITE_DETAILS,
      data: { siteId: siteId },
      meta: {
        onSuccess: (data) => {
          let domainName = data.domainName;
          getStore().dispatch({
            type: Actions.API_GET_SITES_RESTORES,
            data: {
              siteId: siteId,
              stagingDomainName:
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : domainName,
            },
          });
          getStore().dispatch({
            type: data.ebsSite
              ? Actions.API_GET_EBS_BACKUPS_DETAILS
              : Actions.API_GET_BACKUPS_DETAILS,
            data: {
              siteId: siteId,
              stagingDomainName:
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : domainName,
            },
          });
          const selectedEnvData = data.stagingDomainsList.find(
            (list) =>
              list?.environment ===
              (selectedDomain?.environment === "STAGING" ? "STAGING" : "LIVE")
          );
          getStore().dispatch({
            type: Actions.SET_SELECTED_DOMAIN,
            data: selectedEnvData,
          });
        },
        onError: () => {},
      },
    });
    getStore().dispatch({
      type: Actions.SET_SITE_DETAILS,
      data: {
        orgId: orgId,
        siteId: siteId,
        sitePage: lastSegment,
      },
    });
  };

  const ActivatePopup = (
    type,
    fsBackupKey,
    dbBackupKey,
    veleroBackupKey,
    backupId,
    siteName
  ) => {
    if (type === "info-res") {
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Restore Site?",
        popupSubtitle: "Are you sure you want restore the site?",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          setLoading(true);
          setTimeout(() => {
            setLoading(false);
            restoreBackupAPI(fsBackupKey, dbBackupKey, veleroBackupKey);
          }, 5000);
        },
      });
    } else if (type === "info-dedicated-res") {
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Restore Dedicated Site?",
        popupSubtitle: "Are you sure you want restore the site?",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          setLoading(true);
          setTimeout(() => {
            setLoading(false);
            restoreDedicatedBackupAPI(backupId, siteName);
          }, 5000);
        },
      });
    } else if (type === "info-ebs-res") {
      // EBS sites: fsBackupKey = snapshot id, dbBackupKey = the backup's name, veleroBackupKey = its date
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Restore Site?",
        popupSubtitle: `Are you sure you want to restore the site from the backup "${
          dbBackupKey || fsBackupKey
        }`,
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          restoreEbsBackupAPI(fsBackupKey);
        },
      });
    } else if (type === "success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Hurray it's done!!",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Oops!! something went wrong",
        popupSubtitle: "An error occurred. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "process-initiated") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Process Initiated!",
        popupSubtitle:
          "Your request has been received. We will notify you once it's done.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "loading-fs") {
      setPopup({
        popupState: true,
        popupType: "loading",
        popupTitle: "Downloading File System",
        popupSubtitle:
          "Your file system backup download is in progress. Please wait a moment.",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "loading-db") {
      setPopup({
        popupState: true,
        popupType: "loading",
        popupTitle: "Downloading Data Base",
        popupSubtitle:
          "Your database backup download is in progress. Please wait a moment.",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "download-success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Download Successful!",
        popupSubtitle: "Your file has been downloaded successfully.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "download-error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Download Failed!",
        popupSubtitle: "Something went wrong. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "OK",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    }
  };

  const getBackupData = () => {
    const backupsList =
      sites?.backupDetails?.backupList?.map((item) => ({
        backupDate: item?.backupDate,
        label: item?.label,
        pages: item?.pages,
        plugins: item?.plugins,
        themes: item?.themes,
        wpVersion: item?.wpVersion !== null ? item?.wpVersion : "",
        dbBackup: item?.dbBackup,
        fsBackup: item?.fsBackup,
        veleroBackup: item?.veleroBackup,
        status: item?.status,
        name: item?.siteName,
        backupId: item?.backupId,
        type: "Nightly",
      })) || [];

    const onDemandList =
      sites?.backupDetails?.onDemandBackupList?.map((item) => ({
        backupDate: item?.backupDate,
        label: item?.label,
        tag: item?.tag,
        pages: item?.pages,
        plugins: item?.plugins,
        themes: item?.themes,
        wpVersion: item?.wpVersion,
        dbBackup: item?.dbBackup,
        fsBackup: item?.fsBackup,
        veleroBackup: item?.veleroBackup,
        status: item?.status,
        name: item?.siteName,
        backupId: item?.backupId,
        type: "OnDemand",
      })) || [];

    const [fsBackupNightly, dbBackupNightly, veleroBackupNightly] = [
      "fsBackup",
      "dbBackup",
      "veleroBackup",
    ].map((key) => backupsList.find((item) => item[key])?.[key]);

    const [fsBackup, dbBackup, veleroBackup] = [
      "fsBackup",
      "dbBackup",
      "veleroBackup",
    ].map((key) => onDemandList.find((item) => item[key])?.[key]);

    const restoreList = Object.entries(sites?.restoreDetails || {})
      .map(([key, data]) => ({
        dateTime: key,
        restoreId: data.restoreId,
        status: data.status,
        tag: data.tags,
        wpVersion: data.wpVersion,
        processTime: data.totalTime,
        backupType: data.backupType,
      }))
      .sort((a, b) => new Date(b.dateTime) - new Date(a.dateTime));

    return {
      combinedBackupsList: [...backupsList, ...onDemandList],
      fsBackup,
      dbBackup,
      veleroBackup,
      restoreList,
      fsBackupNightly,
      dbBackupNightly,
      veleroBackupNightly,
    };
  };

  const { combinedBackupsList, restoreList } = getBackupData();

  const flushStateVariables = () => {
    setOnDemandName("");
    setLoading(false);
    setOnDemandPopup(false);
  };

  const filteredData = combinedBackupsList.filter((item) => {
    if (filterType === "All") return true;
    return item.type === filterType;
  });

  const onDemandAPI = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOnDemandPopup(false);
      ActivatePopup("process-initiated");
    }, 5000);
    getStore().dispatch({
      type: Actions.API_CREATE_ON_DEMAND,
      data: {
        siteId: siteData?.siteId,
        note: onDemandName,
        stagingDomainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData?.siteName,
      },
      meta: {
        onSuccess: () => {
          getStore().dispatch({
            type: Actions.API_GET_BACKUPS_DETAILS,
            data: {
              siteId: siteId,
              stagingDomainName:
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData?.siteName,
            },
          });
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
          setTimeout(() => {
            setLoading(false);
            setOnDemandPopup(false);
            flushStateVariables();
          }, 5000);
        },
        onError: () => {
          setTimeout(() => {
            setLoading(false);
            setOnDemandPopup(false);
            flushStateVariables();
          }, 5000);
        },
      },
    });
  };

  const dedicatedOnDemandAPI = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOnDemandPopup(false);
      ActivatePopup("process-initiated");
    }, 5000);
    getStore().dispatch({
      type: Actions.API_DEDICATED_ON_DEMAND_BACKUP,
      data: {
        siteName: siteData?.siteName,
        isOnDemand: true,
        tag: onDemandName,
      },
      meta: {
        onSuccess: () => {
          getStore().dispatch({
            type: Actions.API_GET_BACKUPS_DETAILS,
            data: {
              siteId: siteId,
              stagingDomainName:
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData?.siteName,
            },
          });
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
          setTimeout(() => {
            setLoading(false);
            setOnDemandPopup(false);
            flushStateVariables();
          }, 5000);
        },
        onError: () => {
          setTimeout(() => {
            setLoading(false);
            setOnDemandPopup(false);
            flushStateVariables();
          }, 5000);
        },
      },
    });
  };

  const fsbackupAPI = (backupKey) => {
    ActivatePopup("loading-fs");
    getStore().dispatch({
      type: Actions.API_SITE_DOWNLOAD_BACKUP,
      data: { key: backupKey },
      meta: {
        onSuccess: (url) => {
          window.location.href = url;
          ActivatePopup("download-success");
        },
        onError: () => {
          ActivatePopup("download-error");
        },
      },
    });
  };

  const dbBackupAPI = (backupKey) => {
    ActivatePopup("loading-db");
    getStore().dispatch({
      type: Actions.API_SITE_DOWNLOAD_BACKUP,
      data: { key: backupKey },
      meta: {
        onSuccess: (url) => {
          window.location.href = url;
          ActivatePopup("download-success");
        },
        onError: () => {
          ActivatePopup("download-error");
        },
      },
    });
  };

  const restoreDedicatedBackupAPI = (backupId, siteName) => {
    ActivatePopup("process-initiated");
    getStore().dispatch({
      type: Actions.API_RESTORE_DEDICATED_SITE,
      data: {
        backupId,
        siteName,
      },
      meta: {
        onSuccess: () => {
          setLoading(false);
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
        },
        onError: () => {
          setLoading(false);
        },
      },
    });
  };

  // snapshots that were still being created at the last refresh
  const pendingSnapshotIds = useRef(new Set());

  // refresh EBS snapshots every 10 seconds while one is still being created
  useEffect(() => {
    const ebsBackups = [
      ...(sites?.ebsBackupDetails?.backupList || []),
      ...(sites?.ebsBackupDetails?.onDemandBackupList || []),
    ];
    // a snapshot finished (completed or failed): fetch its "Backup created/failed" bell once.
    // The backend checks the snapshot every 15 seconds before writing it, so give it 20
    if (
      ebsBackups.some(
        (item) =>
          item.state !== "pending" &&
          pendingSnapshotIds.current.has(item.snapshotId),
      )
    ) {
      setTimeout(() => {
        getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
      }, 20000);
    }
    pendingSnapshotIds.current = new Set(
      ebsBackups
        .filter((item) => item.state === "pending" && item.snapshotId)
        .map((item) => item.snapshotId),
    );
    if (!isEbsSite || !ebsBackups.some((item) => item.state === "pending")) {
      return;
    }
    const timer = setTimeout(() => {
      getStore().dispatch({
        type: Actions.API_GET_EBS_BACKUPS_DETAILS,
        data: { siteId: siteData?.siteId },
      });
    }, 10000);
    return () => clearTimeout(timer);
  }, [isEbsSite, sites?.ebsBackupDetails]);

  // reload the page data every 10 seconds while an EBS restore is running, then report how it ended
  useEffect(() => {
    if (!isEbsSite) {
      return;
    }
    const restores = Object.values(sites?.restoreDetails || {});
    if (restores.some((item) => item?.status === "RESTORE_PROCESSING")) {
      const timer = setTimeout(fetchData, 10000);
      return () => clearTimeout(timer);
    }
    if (ebsRestoring) {
      setEbsRestoring(false);
      // restoreDetails is keyed by the restore's timestamp
      const latest = Object.entries(sites?.restoreDetails || {})
        .sort(([a], [b]) => new Date(b) - new Date(a))[0]?.[1];
      if (latest?.status === "RESTORE_SUCCESS") {
        toast.success("Restore completed: your site has been restored from the backup.");
      } else if (latest?.status === "RESTORE_FAILED") {
        toast.error("Restore failed: your site is back on its previous data.");
      }
      getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
    }
  }, [isEbsSite, sites?.restoreDetails]);

  // same layout as ActivatePopup("error"), with the message returned by the backend
  const showEbsError = (title, message) => {
    setPopup({
      popupState: true,
      popupType: "error",
      popupTitle: title,
      popupSubtitle: message || "An error occurred. Please try again.",
      popupCancel: false,
      popupButton: true,
      popupButtonTitle: "OK",
      popupButtonFunction: () => {
        setPopup({ popupState: false });
      },
    });
  };

  const createEbsBackupAPI = () => {
    setLoading(true);
    getStore().dispatch({
      type: Actions.API_EBS_CREATE_BACKUP,
      data: { siteId: siteData?.siteId, note: onDemandName },
      meta: {
        onSuccess: (snapshot) => {
          flushStateVariables();
          // the snapshot completes in the background; the backend also writes a bell notification
          ActivatePopup("process-initiated");
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
          // EC2 lists a new snapshot only after a few seconds, so add it to the table right away
          getStore().dispatch({
            type: Actions.SET_EBS_BACKUP_DETAILS,
            data: {
              ...sites?.ebsBackupDetails,
              onDemandBackupList: [
                snapshot,
                ...(sites?.ebsBackupDetails?.onDemandBackupList || []),
              ],
            },
          });
        },
        onError: (errorMessage) => {
          flushStateVariables();
          showEbsError("Backup failed", errorMessage || "Unable to create a backup");
        },
      },
    });
  };

  // 202: the restore runs in the background, the effect above follows it until it finishes
  const restoreEbsBackupAPI = (snapshotId) => {
    setLoading(true);
    getStore().dispatch({
      type: Actions.API_EBS_RESTORE_BACKUP,
      data: {
        siteId: siteData?.siteId,
        snapshotId: snapshotId,
      },
      meta: {
        onSuccess: (data) => {
          setLoading(false);
          if (data?.executed === false) {
            showEbsError(
              "Restore not started",
              data?.message || "Your restore request was accepted but has not been performed yet."
            );
            return;
          }
          // the restore runs in the background; the backend also writes a bell notification
          ActivatePopup("process-initiated");
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
          setEbsRestoring(true);
          selectTab({ title: "Restore", value: "RestoreTable" });
          fetchData();
        },
        onError: (errorMessage) => {
          setLoading(false);
          showEbsError("Restore failed", errorMessage || "Unable to restore from this snapshot");
        },
      },
    });
  };

  const restoreBackupAPI = (fsBackupKey, dbBackupKey, veleroBackupKey) => {
    ActivatePopup("process-initiated");
    getStore().dispatch({
      type: Actions.API_SITE_RESTORE_BACKUP,
      data: {
        siteId: siteData?.siteId,
        dbBackup: dbBackupKey?.split(".")[0],
        fsBackup: fsBackupKey?.split(".")[0],
        veleroBackup: veleroBackupKey,
        stagingDomainName:
          selectedDomain?.environment === "STAGING"
            ? selectedDomain.domainName
            : siteData?.siteName,
      },
      meta: {
        onSuccess: () => {
          setLoading(false);
          getStore().dispatch({
            type: Actions.API_GET_SITES_RESTORES,
            data: {
              siteId: siteData?.siteId,
              stagingDomainName:
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData?.siteName,
            },
          });
          getStore().dispatch({ type: Actions.API_GET_USER_NOTIFICATIONS });
        },
        onError: () => {
          setLoading(false);
        },
      },
    });
  };

  return (
    <>
      <Grid2 className={styles.Container}>
        <Grid2 className={styles.header}>Backups & Restore</Grid2>
        {siteData.siteName && (
          <SiteHeaderCard
            name={
              selectedDomain?.environment === "STAGING"
                ? selectedDomain.domainName
                : siteData.siteName
            }
            domain={
              livedom?.length > 0 &&
              (selectedDomain?.environment !== "STAGING" || isDedicated)
                ? livedom
                : (selectedDomain?.environment === "STAGING"
                    ? selectedDomain.domainName
                    : siteData.siteName) +
                  "." +
                  process.env.REACT_APP_TEMP_DOMAIN
            }
            development={isStaging}
            production={getStagingEnv(siteData.staging, STAGING.LIVE)}
            phpClick={() => adminApi("php")}
            wpClick={() =>
              adminApi(
                "wp",
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData.siteName,
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : livedom?.length > 0
                    ? livedom
                    : null,
                selectedDomain?.environment === "STAGING" ? true : false,
              )
            }
            domainClick={() =>
              adminApi(
                "domain",
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : siteData.siteName,
                selectedDomain?.environment === "STAGING"
                  ? selectedDomain.domainName
                  : livedom?.length > 0
                    ? livedom
                    : null,
                selectedDomain?.environment === "STAGING" ? true : false,
              )
            }
            siteId={siteData.siteId}
            orgId={orgId}
            image={siteData.imagePath ? siteData.imagePath : null}
            orgInfo={organizationsInfo}
            addOnWaf={siteData.wafStatus}
            addOnPerformanceSite={siteData.performanceSite}
          />
        )}

        <Grid2 className={styles.BackupsContainer}>
          <Grid2 className={styles.FlexBox}>
            <TyTabs
              selectedTab={cardStatus}
              setSelectedTab={selectTab}
              tabs={[
                { title: "Backups", value: "BackupTable" },
                { title: "Restore", value: "RestoreTable" },
              ]}
            />
            <Grid2 className={styles.Icons}>
              <Grid2
                className={styles.onDemand}
                onClick={() => {
                  setOnDemandPopup(true);
                }}
              >
                Create On-Demand
              </Grid2>
              <IconButton
                icon={NightlyBackups}
                tooltipText="NightlyBackups"
                onClick={handleNightlyClick}
                isActive={selectedButton === "Nightly"}
              />
              <IconButton
                icon={CloudOnDemandBackups}
                tooltipText="OnDemandBackups"
                onClick={handleOnDemandClick}
                isActive={selectedButton === "OnDemand"}
              />
            </Grid2>
          </Grid2>

          {cardStatus.value === "BackupTable" && isEbsSite && (
            <BackupsTable
              isEbsSite={true}
              filterType={filterType}
              ebsBackupDetails={sites?.ebsBackupDetails}
              restore={(snapshotId, backupName, backupDate) => {
                ActivatePopup("info-ebs-res", snapshotId, backupName, backupDate);
              }}
              userDetails={userDetails}
            />
          )}

          {cardStatus.value === "BackupTable" && !isEbsSite && (
            <BackupsTable
              filterType={filterType}
              data={filteredData}
              fileSystem={(backupKey) => {
                fsbackupAPI(backupKey);
              }}
              dbBackup={(backupKey) => {
                dbBackupAPI(backupKey);
              }}
              restore={(fsBackupKey, dbBackupKey, veleroBackupKey) => {
                ActivatePopup(
                  "info-res",
                  fsBackupKey,
                  dbBackupKey,
                  veleroBackupKey,
                );
              }}
              sites={sites}
              userDetails={userDetails}
              isDedicatedHosting={dedicatedHosting}
              restoreDedicate={(backupId, siteName) => {
                ActivatePopup(
                  "info-dedicated-res",
                  null,
                  null,
                  null,
                  backupId,
                  siteName,
                );
              }}
            />
          )}

          {cardStatus.value === "RestoreTable" && (
            <RestoreTable
              filterType={filterType}
              data={restoreList}
              sites={sites}
              userDetails={userDetails}
              isDedicatedHosting={dedicatedHosting}
            />
          )}
        </Grid2>

        <Popup
          trigger={onDemandPopup}
          closePopup={() => flushStateVariables()}
          header={"Create Production Backup"}
          subHeader={"Secure your website now"}
        >
          <CustomInput
            title="Description (optional)"
            placeholder="Desc for this backup"
            value={onDemandName}
            setValue={(e) => {
              const sanitized = e
                .replace(/^\s+/, "")
                .replace(/[^a-zA-Z0-9 ]/g, "");

              setOnDemandName(sanitized);
            }}
          />
          <Grid2 className={styles.noteContainer}>
            <Grid2 className={styles.noteLabel}>NOTE:</Grid2>
            <Grid2 className={styles.noteText}>
              The backup will take about 5 minutes to create. Thanks for
              waiting!
            </Grid2>
          </Grid2>
          <Grid2 className={styles.create}>
            <Grid2
              className={styles.button}
              onClick={() => {
                // one request per click: the button shows a spinner until the backend answers
                if (loading) {
                  return;
                }
                dedicatedHosting
                  ? dedicatedOnDemandAPI()
                  : isEbsSite
                  ? createEbsBackupAPI()
                  : onDemandAPI();
              }}
            >
              {loading ? (
                <CircularProgress size={CP.SIZE} color={CP.COLOR} />
              ) : (
                "create"
              )}
            </Grid2>
          </Grid2>
        </Popup>
      </Grid2>
      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        loading={loading}
        cancelTitle={popup.popupCancelTitle}
        cancelFunction={popup.popupCancelFunction}
      />
    </>
  );
}
